import { FC } from 'react';
import MinkaChange from './MinkaChange';
import UseMinkaChange from './UseMinkaChange';

const MikaChangeContainer: FC = () => {
  return <MinkaChange {...UseMinkaChange()} />;
};

export default MikaChangeContainer;
